import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')

const ROUTE_NAME = 'profile:returns:'

const p = name => ROUTE_NAME + name

const LIST = p('list')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([TYPES.SHIPPER, TYPES.MANAGER, TYPES.ADMINISTRATOR, TYPES.STOREKEEPER, TYPES.STOCK_INFO, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR, TYPES.STORE_WH], options),
      },
    }),
  ]
}
